<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <pb-body-base :busy="busy">
        <template v-slot:default="props">
            <pb-body banner-size="sm"
                     :banner-img="fileResourceUrl($route.params.parentCategory ? category.headerImage : category.bannerImage)"
                     :breadcrumbs="breadcrumbs"
                     :page-title="(category.webName || category.name)">
                <template slot="settings">
                    <b-row>
                        <b-col class="my-4">
                            <div class="input-group">
                                <b-input-group-prepend is-text><span class="icon-search"></span></b-input-group-prepend>
                                <b-form-input
                                        style="background-color: #F1F1F1; border: none;"
                                        class="secondary"
                                        id="filter"
                                        name="filter"
                                        size="lg"
                                        type="text"
                                        placeholder="article name / number / description"
                                        v-debounce:300="onFilter"
                                        :value="filterString"
                                ></b-form-input>
                                <b-button size="lg" @click="openSidebar()" :disabled="!currentFilterList" class="ml-2"
                                          variant="primary">Filter &
                                    Category <i
                                            class="fal fa-inline fa-sliders-h"></i></b-button>
                            </div>
                        </b-col>
                    </b-row>
                </template>
                <template slot="body">
                    <pb-article-filter v-if="currentFilterList && currentFilterList.length > 0"
                                       key="uniqueKey"
                                       ref="sidebar"
                                       @filteredArticleCount="prefetchArticleCount"
                                       :current-filter-list="currentFilterList"
                                       :count="count"
                                       :busy="loadingFilter"
                                       :category="category">
                    </pb-article-filter>
                    <b-container>
                        <b-row v-if="activeFilterItems && activeFilterItems.length > 0" class="mb-4"  align-v="center">
                            <b-col>
                                <b-row>
                                    <b-col md="4" :key="filter.key" v-for="(filter) in activeFilterItems">
                                        <h6>{{ $t(`filter_key_${filter.key}`) }}</h6>
                                        <div :key="filterItem.id + index" v-for="(filterItem, index) in filter.items"
                                             class="filter-btn active" block active pill>
                                            <b-button v-if="filterItem.active" @click="openSidebar()"
                                                      class="filter-btn" pill>
                                                {{filterItem.label || $t(`filter_item_label_${filterItem.id}`)}}
                                            </b-button>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-col cols="12" md="auto">
                                <b-row>
                                    <b-col>
                                        <b-button @click="$refs.sidebar.reset()">
                                            <i class="fal fa-times"></i> REMOVE FILTER
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                        <b-row :key="filteredCategory.id"
                               v-for="(filteredCategory) in filteredArticlesGroupedByCategory" class="mb-3">
                            <b-col>

                                <div v-if="category.id !== filteredCategory.categoryId">
                                    <h3 class="my-4">{{filteredCategory.categoryName}}</h3>
                                    <hr class="left mt-1 mb-4"/>
                                </div>
                                <div v-if="filteredCategory.bannerImage" class="divider-img mb-4">
                                    <img @error="$event.target.style.display='none'"
                                         :src="fileResourceUrl(filteredCategory.bannerImage)"/>
                                </div>
                                <b-row>
                                    <router-link :key="article.id"
                                                 class="col-md-4 col-lg-2dot4 article-link mb-2 card-deck"
                                                 v-for="(article) in filteredCategory.articles"
                                                 :to="{name: 'ar', params: {categoryId: category.id, articleId: article.id, variantId: article.colorId}}">
                                        <pb-card :img-info="article.name">
                                            <template slot="image">
                                                <div v-if="article.neverOutOfStock" class="nos-img"></div>
                                                <img :src="imageResource((article.webImage || article.image), 240)"
                                                     alt="thumbnail"/>
                                            </template>
                                            <template slot="content">
                                                <span class="d-block">{{article.primaryDescription || article.secondaryDescription}}</span>
                                                <span class="d-block"><small>{{`${article.colorAmount} colors | ${article.sizeAmount} sizes`}}</small></span>
                                            </template>
                                        </pb-card>
                                    </router-link>
                                </b-row>
                                <b-row v-if="user && canRead('collection_moods')">
                                    <b-col>
                                        <div class="divider-img mb-4"  v-if="filteredCategory.meta && filteredCategory.meta.tile && filteredCategory.meta.tile.categoryBannerImage">
                                            <router-link
                                                    :to="{ name: 'theme', params : {season : filteredCategory.meta.tile.season}, hash: '#' + filteredCategory.meta.tile.id}">
                                                <img @error="$event.target.style.display='none'"
                                                     class="divider-img mb-4"
                                                     :src="fileResourceUrl(filteredCategory.meta.tile.categoryBannerImage)"/>
                                            </router-link>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </b-container>
                </template>
            </pb-body>
        </template>
    </pb-body-base>
</template>


<script>

    import CategoryApi from "@shared/_api/category";
    import ArticleFilter from "../../components/article/ArticleFilter";
    import CategoryBase from "./CategoryBase";
    import ContentAPI from "../../../../../shared/_api/cms/content";

    export default {
        name: 'pb-category',
        extends: CategoryBase,
        components: {
            'pb-article-filter': ArticleFilter
        },
        data: function () {
            return {
                pageSize: 10,
                currentPage: 1,
                meta: undefined,
                filterConfig: ['category', 'nos', 'material', 'size']
            }
        },
        methods: {
            fetchCategory(id, queryparam) {
                this.busy = true;
                Promise.all([ContentAPI.fetchListByName("category-meta"), ContentAPI.fetchListByName("design-shop")]).then(([categoryMetaList, designShopTileList]) => {
                    let designShopTileMap = new Map();
                    designShopTileList.forEach((item) => {
                        designShopTileMap.set(item.id, item);
                    });
                    let categoryMetaMap = new Map();
                    categoryMetaList.forEach((item) => {

                        let tile = null,
                            tileId = item['trend-shop-card'].value;

                        if (designShopTileMap.has(tileId) && designShopTileMap.get(tileId)['category_banner']) {
                            tile = {
                                id: tileId,
                                categoryBannerImage: designShopTileMap.get(tileId)['category_banner'].value,
                                season: designShopTileMap.get(tileId).tile.value.season
                            }
                        }

                        categoryMetaMap.set(item.category.value, {
                            order: item.order.value,
                            tile: tile
                        });
                    });
                    return categoryMetaMap;
                }).catch((e) => {
                    console.log(e);
                }).then((categoryMetaMap) => {
                    return CategoryApi.byId(id, queryparam).then(category => {
                        if (categoryMetaMap && category.childrenCategoryList) {
                            if (categoryMetaMap.has(category.id)) {
                                category.meta = categoryMetaMap.get(category.id);
                            }

                            const setMeta = (subCategory) => {
                                if (categoryMetaMap.has(subCategory.id)) {
                                    subCategory.meta = categoryMetaMap.get(subCategory.id);
                                }
                                subCategory.childrenCategoryList && subCategory.childrenCategoryList.forEach(setMeta);
                            };
                            category.childrenCategoryList.forEach(setMeta);
                        }

                        this.category = category;
                        this.$tracker.trackView({label: category.name, type: 'CATEGORY'}, this.user);
                        this.count = this.filteredArticles.length;
                    })
                }).finally(() => {
                    this.busy = false;
                });

                this.fetchFilter(id, queryparam);
            },
            prefetchArticleCount(queryParam) {
                this.loadingFilter = true;
                CategoryApi.byId(this.category.id, queryParam).then(category => {
                    this.count = this.applyFilter(category, true).length;
                }).finally(() => {
                    this.loadingFilter = false;
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import "~@shared/_assets/scss/constants";

    .divider-img {
        max-height: 300px;

        img {
            object-fit: cover;
            width: 100%;
            height: 100%;
        }

    }

    .card-deck {

        .article-number {
            display: none;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 100%;
            padding: 10px;
            border-right: 20px solid transparent;
            overflow: hidden;
            position: absolute;
            text-align: right;
            z-index: 999;
        }

        &:hover {

            .article-number {
                display: block;
            }

        }
    }

</style>
